<template>
    <span>
        <b-btn @click="modal = true" variant="info" pill size="sm">
            <font-awesome-icon icon="fa-duotone fa-info-circle" />
            {{ $t("Guide") }}
        </b-btn>
        <b-modal
            centered
            v-model="modal"
            :title="$t('Gallery Guide')"
            hide-footer
        >
            <creator-gallery-guide-content />
        </b-modal>
    </span>
</template>


<script>
import CreatorGalleryGuideContent from "@/components/creator/gallery/CreatorGalleryGuideContent";

export default {
    data() {
        return {
            modal: false,
        };
    },
    components: {
        CreatorGalleryGuideContent,
    },
};
</script>